import {
  SET_ADDRESS,
  SET_CITY,
  SET_STATE_NAME,
  SET_BVN_ID,
  SET_KYC_DOCS,
  SUPPORT_MAIL,
  BUSINESS_MAIL,
  CHARGE_BACK_MAIL,
  BANK_NAME,
  ACCOUNT_NUMBER,
  BANK,
  RESET_FORM
} from "../redux/formAction";

const initialState = {
  businessMail: "",
  address: "",
  city: "",
  stateName: "",
  bvnId: "",
  businessEmail: "",
  supportEmail: "",
  chargeBackEmail: "",
  selectedBank: "",
  accountNum:"",
  value: [],
};

export default function formReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ADDRESS:
      return { ...state, address: action.payload };
    case SET_CITY:
      return { ...state, city: action.payload };
    case SET_STATE_NAME:
      return { ...state, stateName: action.payload };
    case SET_BVN_ID:
      return { ...state, bvnId: action.payload };
    case SET_KYC_DOCS:
      return { ...state, value: action.payload };
    case BUSINESS_MAIL:
      return { ...state, businessEmail: action.payload };
    case CHARGE_BACK_MAIL:
      return { ...state, chargeBackEmail: action.payload };
    case SUPPORT_MAIL:
      return { ...state, supportEmail: action.payload };
    case BANK:
      return { ...state, selectedBank: action.payload };
    case BANK_NAME:
      return { ...state, selectedBankName: action.payload };
    case ACCOUNT_NUMBER:
      return { ...state, accountNum: action.payload };
    case RESET_FORM:
      return initialState;
    default:
      return state;
  }
}
